<template>
    <div>
        <v-card>
            <v-card-actions class="mx-3">
                <v-spacer />
                <v-btn class="mr-3 mb-3 mt-2 white--text" small color="green" depressed @click="export2xls">Export to XLS</v-btn>
            </v-card-actions>
            <v-card-subtitle>
                <div style="text-align:center; font-weight:bold; font-size:16px; padding:10px">AMBIL STOK ADELPHI</div>

                <v-row class="compact-form my-2">
                    <v-col cols="1">
                        Report
                    </v-col>
                    <v-col cols="2">
                        <v-select :items="valueTypes" item-text="description" item-value="code" v-model="valueType" outlined dense hide-details="auto" />
                    </v-col>
                    <v-col cols="1">
                        Tanggal Delivery
                    </v-col>
                    <v-col cols="2">
                        <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="date"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="1">
                        Volume
                    </v-col>
                    <v-col cols="2">
                        <v-select :items="volumes" item-text="description" item-value="code" v-model="volume" outlined dense hide-details="auto" />
                    </v-col>
                    <v-col cols="2">
                        <v-btn depressed color="primary" @click="runReport">Run</v-btn>
                    </v-col>
                </v-row>
            </v-card-subtitle>
            <v-card-text class="">
                <div id="printresep" style="overflow: auto;">
                    <v-simple-table fixed-header height="500px" id="variantTbl" ref="tableBOM">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th width="10" rowspan="2">No</th>
                                    <th width="10" rowspan="2">Kode</th>
                                    <th class="text-center">{{ volume }} ml</th>
                                    <th class="text-center" rowspan="2">TOTAL</th>
                                    <th class="text-center" v-for="(coord, icoord) in coordinators" :key="icoord">{{ coord.coordinator_name }}</th>
                                </tr>
                                <tr>
                                    <th class="text-center">Expired</th>
                                    <th class="text-center" v-for="(coord, icoord) in coordinators" :key="icoord">{{ coord.expired_date }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(product, pidx) in products" :key="product.product_code">
                                    <td>{{ pidx + 1 }}</td>
                                    <td>{{ product.product_code }}</td>
                                    <td>{{ product.product_name }}</td>
                                    <td class="text-center">{{ getQtyTotal(product.product_code) || '' }}</td>
                                    <td class="text-center" v-for="(coord, icoord) in coordinators" :key="icoord">
                                        {{ getQtyCoordinator(coord, product.product_code) || '' }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="3" class="text-right">Jumlah Total</th>
                                    <th class="text-center">{{ sumQty || '' }}</th>
                                    <th class="text-center" v-for="(coord, icoord) in coordinators" :key="icoord">
                                        {{ sumQtyCoordinator(coord) || '' }}
                                    </th>
                                </tr>
                            </tfoot>
                        </template>
                    </v-simple-table>
                </div>
            </v-card-text>
        </v-card>

        <v-overlay :value="isLoading" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>  
    </div>
</template>

<script>
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data: () => ({
        isLoading: false,
        dateMenu: false,
        date: null,
        volume: '490',
        volumes: [],
        products: [],
        coordinators: [],
        items: [],
        days: [],
        valueTypes: [{code:'A', description:'Ambil Stok Adelphi'},{code:'S', description:'Sisa Stok'}],
        valueType: 'A',
    }),

    async created() {
        this.date = moment().format('YYYY-MM-DD');
        this.getVolumes();

        this.getData();
    },

    computed: {
        sumQty() {
            return this.products.reduce((total, item) => total + this.getQtyTotal(item.product_code), 0);
        },
    },

    methods: {
        runReport() {
            this.getData();
        },
        getVolumes() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.volumes = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        getQtyCoordinator(data, productCode) {
            let result = 0;

            const item = this.items.find((item) => item.variant_code == productCode 
                && item.coordinator_code == data.coordinator_code);
            if (item) {
                result = parseInt(item.quantity) || 0;
            }

            return result;
        },
        sumQtyCoordinator(data) {
            return this.products.reduce((total, item) => total + this.getQtyCoordinator(data, item.product_code), 0);
        },
        getQtyTotal(productCode) {
            let result = 0;

            this.coordinators.forEach(item => {
                result += this.getQtyCoordinator(item, productCode);
            });

            return result;
        },
        async getData() {
            this.isLoading = true;
            
            try {
                const data = (await this.$store.dispatch('getObjs', {apidomain:'reports/ambil-stok-adelphi?type='+this.valueType+'&delivery_date='+this.date+'&size='+this.volume, parameter:''})).data.data;
                console.log(data);
                this.coordinators = data.coordinators;
                this.products = data.products;
                this.items = data.items;
            } catch (error) {
                console.log('Error fetching data:', error);
            } finally {
                this.isLoading = false;
            }
        },
        export2xls() {
            console.log(this.$refs.tableBOM.$el.firstChild.firstChild);
            const wb = utils.table_to_book(this.$refs.tableBOM.$el.firstChild.firstChild);
            writeFileXLSX(wb, "Ambil-Stok-Adelphi.xlsx");
        },
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>